<script setup>
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

const props = defineProps({
  filteredItems: { type: Array, required: true },
  store: { type: Object, required: true }
})

const store = props.store
const { selectedItems } = storeToRefs(props.store)

const isSelected = computed({
  get: () => {
    return props.filteredItems.every((item) => selectedItems.value.includes(item))
  },
  set: (value) => {
    store.updateSelectedItems(value, props.filteredItems)
  }
})
</script>

<template>
  <v-row align="center">
    <v-col>
      <v-checkbox
        v-model="isSelected"
        label="Select all"
        class="select-all-checkbox"
        color="primary"
        density="compact"
        hide-details
        v-if="props.filteredItems?.length"
      />
    </v-col>
  </v-row>
</template>

<style scoped></style>
